<template>
  <div class="resourceWrapper">
    <h3 class="resourceTitle">
      Resource Library
    </h3>

    <div class="tagContainer">
      <button :class="{initial: resourceTags.indexOf('Sales') == -1}" @click="setFilterTag('Sales')" v-if="tagFilters.salesFilter" >
        <i class="zmdi zmdi-money"></i>
        SALES
      </button>
      <button id='serviceButton' :class="{initial: resourceTags.indexOf('Service') == -1}"  @click="setFilterTag('Service')"  v-if="tagFilters.serviceFilter">
        <i class="zmdi zmdi-car" ></i>
        SERVICE
      </button>
      <button :class="{initial: resourceTags.indexOf('Parts') == -1}"  @click="setFilterTag('Parts')" v-if="tagFilters.partsFilter">
        <i class="zmdi zmdi-wrench"></i>
        PARTS
      </button>
    </div>

    <div class="searchContainer">
      <singleSelect>
        <select @change="setTypeFliter()" ref="TypeFilter" slot="singleSelectMain">
          <option :selected="resourceTypeFilter === 'ANY'">ALL</option>
          <option :selected="resourceTypeFilter === 'link'">LINKS</option>
          <option :selected="resourceTypeFilter === 'pdf'">DOCS</option>
        </select>
      </singleSelect>

      <inputTemplate class="inputWrapper" :hasIcon="true">
        <i class="zmdi zmdi-search" slot="inputIcon"></i>
        <input type="text" ref="searchbar" :value="resourceNameFilter" class="searchBar_resources" @keyup="filterByName()" slot="inputEl">
      </inputTemplate>
    </div>

    <div class="resourceContainer">
      <resourceItem :resource="resource" v-for="resource in filteredResources" :key="resource.id">
      </resourceItem>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapState, mapGetters } from 'vuex' 
import axios from 'axios';
import singleSelect from '@/components/singleSelect.vue'
import inputTemplate from '@/components/inputTemplate.vue'
import resourceItem from '@/components/resourceItem.vue'
require('../assets/css/resources.css')

  export default {
    name: 'resources',
    props: ['videoOpen', 'callerOpen', 'dialerOpen'],
    components:{
      singleSelect,
      inputTemplate,
      resourceItem
    },
    data: function () {
      return {
        selectedTag: [],
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        account: state => state.account,
        mainResources: state => state.resources,
        filteredResources: state => state.filteredResources,
        tagFilters: state => state.tagFilters,
        resourceTags: state => state.resourceTags,
        resourceTypeFilter: state => state.resourceTypeFilter,
        resourceNameFilter: state => state.resourceNameFilter
      })
    },
    methods: {
      setFilterTag: function(tagName){
        this.$store.commit({
          type: 'updateResourceTagFilter',
          tag: tagName
        })

        this.$store.commit({
          type: 'updateFilteredResources'
        })
      },
      setTypeFliter: function(){
        var chosenOption = this.$refs.TypeFilter.value

        if (chosenOption === 'LINKS') {
          chosenOption = 'link'
        } else if (chosenOption === 'DOCS') {
          chosenOption = 'pdf'
        } else {
          chosenOption = 'ANY'
        }

        this.$store.commit({
          type: 'updateResourceTypeFilter',
          resourceType: chosenOption
        })

        this.$store.commit({
          type: 'updateFilteredResources'
        })
      },
      filterByName: function(){
        this.$store.commit({
          type: 'updateResourceNameFilter',
          search: this.$refs.searchbar.value.toLowerCase()
        })

        this.$store.commit({
          type: 'updateFilteredResources'
        })
      }
    }
  }
</script>
